import WebPushApi from './Services/WebPushApi'

export default {
  WebPushApi,
}
